module.exports = __webpack_public_path__ + "static/media/score.0875be74.svg";